<div class="report-dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0 mb-24">
        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{title}}</span>
            <button mat-icon-button class="mat-icon-button white-fg" (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0 pt-0" fusePerfectScrollbar>
        <form [formGroup]="form" #formControl="ngForm" fxLayout="column" fxFlex>               
            <mat-form-field color="accent" class="report-name w-100-p p-8 m-0 form-control" > 
                <mat-label>Name</mat-label>
                <input id="name" matInput #input class="form-control" formControlName="name" matInput 
                    name="name" [setFocus]="true" max-length="200" [readonly]="readOnly" required>
            </mat-form-field>
            <validation-errors [control]="form.get('name')" style="padding-left: 8px;"></validation-errors>
            
            <mat-form-field class="w-100-p p-8 m-0 form-control">
                <mat-label>Description</mat-label>
                <textarea matInput name="description" formControlName="description" rows="1" matInput 
                    maxlength="500" [readonly]="readOnly">
                </textarea>
            </mat-form-field>
        </form>
    </div>
    <div *ngIf="!readOnly" mat-dialog-actions class="m-0 p-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div>
            <button id="btnSave" mat-raised-button type="submit"
                [disabled]="((!form.valid) || (form.pristine && (!this.report?.id)))" (click)="save()"
                class="save-button mat-accent" aria-label="Save">
                {{btnSaveLabel}}
            </button>
        </div>
    </div>
</div>